<template>
    <div id="app">
        <Header/>
        <router-view/>
        <Footer/>
    </div>
</template>

<script>
import Header from './views/Header.vue'
import Footer from './views/Footer.vue'

export default {
    components: {
        Header,
        Footer
    }
}
</script>

<style>
#app {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #555;
}

html,
body,
ul,
p,
textarea,
input,
#app {
    margin: 0;
    padding: 0;
}

li {
    list-style: none;
}

a {
    text-decoration: none;
    transition: all .3s ease-in-out;
}

img {
    display: block;
}

textarea {
    outline: none;
}

input {
    border: none;
}

.content-box {
    display: flex;
    justify-content: space-between;
    max-width: 1100px;
    margin: 0 auto 40px auto;
}

/* 左边布局 */
.left-box {
    flex: 1;
}

.left-box .title-box .el-link {
    font-weight: bold;
}

/* 导航菜单 */
#app .el-menu--horizontal>.el-menu-item {
    font-weight: bold;
    height: 40px;
    line-height: 40px;
}

#app .el-menu--horizontal>.el-menu-item.is-active {
    color: #fff;
    background: #409eff;
}

/* 查看更多 */
.more-box .el-button {
    width: 100%;
}


/* 响应式 */
@media(max-width: 1100px) {
    .content-box {
        display: initial;
    }

    .left-box {
        width: 90%;
        margin: auto;
    }

    #app .el-menu--horizontal>.el-menu-item {
        height: 30px;
        line-height: 30px;
    }
}
</style>
